// import React, { useEffect, useState } from "react";
// import { CoordinateTierCategoryInterface } from "../../interfaces/pincode-tier.interface";
// import { post } from "../../redux/ApiHelper";

// const AddOrEditTierSetupModal = ({
//   isOpen,
//   closeModal,
//   isEdit,
//   editData,
// }: {
//   isOpen: boolean;
//   closeModal: () => void;
//   isEdit?: boolean;
//   editData?: CoordinateTierCategoryInterface;
// }) => {
//   const [tierData, setTierData] = useState<CoordinateTierCategoryInterface>({
//     center: {
//       type: "Point",
//       coordinates: [null, null],
//     },
//     radius: null,
//     tierType: "",
//     name: "",
//   });
//   const [errors, setErrors] = useState<{ pinCode?: string; tierType?: string }>(
//     {}
//   );

//   useEffect(() => {
//     if (isEdit && editData) {
//       setTierData({
//         pinCode: editData.pinCode?.toString() || "",
//         tierType: editData.tierType || "",
//       });
//     } else {
//       setTierData({ pinCode: "", tierType: "" });
//     }
//   }, [isEdit, editData]);

//   const handleChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
//   ) => {
//     const { name, value } = e.target;
//     setTierData((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: undefined }));
//   };

//   const validate = () => {
//     const newErrors: { pinCode?: string; tierType?: string } = {};

//     if (!tierData.pinCode) {
//       newErrors.pinCode = "Pin code is required";
//     } else if (!/^\d{6}$/.test(tierData.pinCode)) {
//       newErrors.pinCode = "Pin code must be a 6-digit number";
//     }

//     if (!tierData.tierType) {
//       newErrors.tierType = "Tier type is required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validate()) return;

//     try {
//       if (isEdit && editData) {
//         // TODO: Add update API logic here
//       } else {
//         const res = await post(`/admin/pin-tier/add`, {
//           pinCode: Number(tierData.pinCode),
//           tierType: tierData.tierType,
//         });
//         console.log(res);
//       }
//       closeModal();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg max-h-screen overflow-auto">
//         <h2 className="text-xl font-semibold text-gray-800 mb-4">
//           {isEdit ? "Update" : "Create New"} Pincode and Tier Setup
//         </h2>

//         <div className="space-y-4">
//           <div>
//             <label className="block text-gray-700">Pin code</label>
//             <input
//               name="pinCode"
//               value={tierData.pinCode}
//               type="number"
//               onChange={handleChange}
//               placeholder="Ex - 700001"
//               className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
//                 errors.pinCode ? "border-red-500" : "border-gray-300"
//               }`}
//             />
//             {errors.pinCode && (
//               <p className="text-red-500 text-sm mt-1">{errors.pinCode}</p>
//             )}
//           </div>

//           <div>
//             <label className="block text-gray-700">Tier type</label>
//             <select
//               name="tierType"
//               value={tierData.tierType}
//               onChange={handleChange}
//               className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
//                 errors.tierType ? "border-red-500" : "border-gray-300"
//               }`}
//             >
//               <option value="">Please select</option>
//               <option value="TIER1">Tier 1</option>
//               <option value="TIER2">Tier 2</option>
//               <option value="TIER3">Tier 3</option>
//               <option value="SUB_URBAN">Sub Urban</option>
//               <option value="RURAL">Rural</option>
//             </select>
//             {errors.tierType && (
//               <p className="text-red-500 text-sm mt-1">{errors.tierType}</p>
//             )}
//           </div>
//         </div>

//         <div className="mt-6 flex justify-end space-x-3">
//           <button
//             onClick={closeModal}
//             className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700"
//           >
//             {isEdit ? "Update" : "Create"} PinCode and Tier
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddOrEditTierSetupModal;

import React, { useEffect, useState } from "react";
import { CoordinateTierCategoryInterface } from "../../interfaces/pincode-tier.interface";
import { post, put } from "../../redux/ApiHelper";
import { successToast } from "../../utils/toast.util";

const AddOrEditTierSetupModal = ({
  isOpen,
  closeModal,
  isEdit,
  editData,
  setSubmittedCount,
}: {
  isOpen: boolean;
  closeModal: () => void;
  isEdit?: boolean;
  editData?: CoordinateTierCategoryInterface;
  setSubmittedCount;
}) => {
  const [tierData, setTierData] = useState<CoordinateTierCategoryInterface>({
    center: {
      type: "Point",
      coordinates: [null, null], // [longitude,latitude ]
    },
    radius: null,
    tierType: "",
    name: "",
  });

  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (isEdit && editData) {
      setTierData({ ...editData });
    } else {
      setTierData({
        center: { type: "Point", coordinates: [null, null] },
        radius: null,
        tierType: "",
        name: "",
      });
    }
  }, [isEdit, editData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "latitude" || name === "longitude") {
      const index = name === "longitude" ? 0 : 1;
      setTierData((prev) => ({
        ...prev,
        center: {
          ...prev.center,
          coordinates: prev.center.coordinates.map((c, i) =>
            i === index ? (value === "" ? null : parseFloat(value)) : c
          ) as [number, number],
        },
      }));
    } else if (name === "radius") {
      setTierData((prev) => ({
        ...prev,
        radius: value ? parseFloat(value) : null,
      }));
    } else {
      setTierData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors: Record<string, string> = {};
    const [lon, lat] = tierData.center.coordinates;

    if (lat == null || isNaN(lat)) newErrors.latitude = "Latitude is required";
    if (lon == null || isNaN(lon))
      newErrors.longitude = "Longitude is required";
    if (tierData.radius == null || tierData.radius <= 0)
      newErrors.radius = "Radius must be greater than 0";
    if (!tierData.tierType) newErrors.tierType = "Tier type is required";
    if (!tierData.name.trim()) newErrors.name = "Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      if (isEdit && editData) {
        // TODO: Update logic
        const res = await put(`/admin/pin-tier/update/${editData._id}`, {
          lon: tierData.center.coordinates[0],
          lat: tierData.center.coordinates[1],
          name: tierData.name,
          radius: tierData.radius,
          tierType: tierData.tierType,
        });
        setSubmittedCount((prev) => prev + 1);
        successToast(res?.message || "Updated successfully");
      } else {
        const res  = await post(`/admin/pin-tier/add`, {
          lon: tierData.center.coordinates[0],
          lat: tierData.center.coordinates[1],
          name: tierData.name,
          radius: tierData.radius,
          tierType: tierData.tierType,
        });
        successToast(res?.message || "Added successfully");
        setSubmittedCount((prev) => prev + 1);
      }
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg max-h-screen overflow-auto">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          {isEdit ? "Update" : "Create New"} Coordinate Tier Setup
        </h2>

        <div className="space-y-4">
          <div>
            <label className="block text-gray-700">Name</label>
            <input
              name="name"
              value={tierData.name}
              onChange={handleChange}
              placeholder="Area name"
              className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
                errors.name ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.name && (
              <p className="text-red-500 text-sm mt-1">{errors.name}</p>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700">Latitute</label>
              <input
                name="latitude"
                type="number"
                value={tierData.center.coordinates[1] ?? ""}
                placeholder="Ex - 22.5726"
                onChange={handleChange}
                className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
                  errors.longitude ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.longitude && (
                <p className="text-red-500 text-sm mt-1">{errors.longitude}</p>
              )}
            </div>
            <div>
              <label className="block text-gray-700">Longitude</label>
              <input
                name="longitude"
                type="number"
                value={tierData.center.coordinates[0] ?? ""}
                onChange={handleChange}
                placeholder="Ex - 88.3639"
                className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
                  errors.latitude ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.latitude && (
                <p className="text-red-500 text-sm mt-1">{errors.latitude}</p>
              )}
            </div>
          </div>

          <div>
            <label className="block text-gray-700">Radius (km)</label>
            <input
              name="radius"
              type="number"
              value={tierData.radius ?? ""}
              onChange={handleChange}
              placeholder="Ex - 10"
              className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
                errors.radius ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.radius && (
              <p className="text-red-500 text-sm mt-1">{errors.radius}</p>
            )}
          </div>

          <div>
            <label className="block text-gray-700">Tier Type</label>
            <select
              name="tierType"
              value={tierData.tierType}
              onChange={handleChange}
              className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 ${
                errors.tierType ? "border-red-500" : "border-gray-300"
              }`}
            >
              <option value="">Please select</option>
              <option value="TIER1">Tier 1</option>
              <option value="TIER2">Tier 2</option>
              <option value="TIER3">Tier 3</option>
              <option value="SUB_URBAN">Sub Urban</option>
              <option value="RURAL">Rural</option>
            </select>
            {errors.tierType && (
              <p className="text-red-500 text-sm mt-1">{errors.tierType}</p>
            )}
          </div>
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={closeModal}
            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700"
          >
            {isEdit ? "Update" : "Create"} Circle
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOrEditTierSetupModal;
